<button
  type="button"
  title="{{ btnTitle }}"
  #btn
  id="{{ id }}"
  class="aui-button {{ classNames }}"
  [disabled]="disabled"
  (click)="clickedButton()"
  appTooltip
>
  <ng-container *ngIf="iconType">
    <ng-container *ngTemplateOutlet="icon; context { iconType, iconClasses }"></ng-container>&nbsp;
  </ng-container>
  <ng-content> </ng-content>
</button>

<ng-template #icon let-iconType="iconType" let-iconClasses="iconClasses">
  <app-icon [type]="iconType" [classNames]="iconClasses || ''"></app-icon>
</ng-template>
